export default "<a [href]=\"url\" target=\"_blank\">\n  <img src=\"/assets/img/badges/google-play-badge-v2.png\" />\n</a>\n"